import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// @ts-check
import React, { useMemo } from "react";
import { formatFromServer, groupTrivias } from "./util";
import trivias from "./trivias";
import { CONTAINER_TRIVIA_BEGIN } from "./positions";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var prepareTrivias = function prepareTrivias(items) {
  var groups = groupTrivias((items || []).map(formatFromServer));

  // Add author at the top
  var grp = groups[CONTAINER_TRIVIA_BEGIN];
  if (trivias.Author && grp) {
    var author = grp.findIndex(function (t) {
      return t.name === "Author";
    });
    if (author < 0) {
      var expert = grp.find(function (t) {
        var _t$props$content;
        return (_t$props$content = t.props.content) === null || _t$props$content === void 0 ? void 0 : _t$props$content.expert;
      });
      if (expert) {
        grp.unshift(_objectSpread(_objectSpread({}, trivias.Author), {}, {
          props: {
            name: "Author",
            content: {
              expert: expert.props.content.expert
            }
          }
        }));
      }
    } else if (author > 0) {
      grp.unshift.apply(grp, _toConsumableArray(grp.splice(author, 1)));
    }
  }
  return groups;
};

/**
 * @param {import("./defineTrivia").CommonTriviaProps} item
 */
var TriviaItem = function TriviaItem(item) {
  if (!item.name || !trivias[item.name]) {
    return null;
  }
  var Component = trivias[item.name].Component;
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, item));
};

/**
 * Show trivias for a position
 * @param {{
 *  position: keyof import("./positions"),
 *  groups: import("./util").TriviaGroup,
 *  trivias?: [],
 *  children?: JSX.Element
 * }} props
 * @return {JSX.Element}
 */
export var Trivias = function Trivias(_ref) {
  var position = _ref.position,
    groups = _ref.groups,
    trivias = _ref.trivias,
    children = _ref.children;
  if (!groups && trivias) {
    groups = prepareTrivias(trivias);
  }
  var content = groups && groups[position] ? /*#__PURE__*/_jsx(_Fragment, {
    children: groups[position].map(function (item, i) {
      return /*#__PURE__*/_jsx(TriviaItem, _objectSpread({}, item.props), "".concat(item.props.name, "_").concat(i));
    })
  }) : null;
  if (!content) {
    return null;
  }
  if (children && React.Children.only(children)) {
    return /*#__PURE__*/React.cloneElement(children, {
      children: content
    });
  } else {
    return content;
  }
};

/**
 * Group trivias by position for use in the Trivias component
 * @param {import("./defineTrivia").CommonTriviaProps[]} trivias
 */
export var useTrivias = function useTrivias(trivias) {
  return useMemo(function () {
    return prepareTrivias(trivias);
  }, [trivias]);
};
//# sourceMappingURL=index.js.map